import cx from 'classnames'
import { Fragment } from 'react'

import '@/components/Review/ReviewDetail/ReviewDetail.scss'
import ReviewStar from '@/components/Review/ReviewStar'
import ReviewStars from '@/components/Review/ReviewStars'
import { ReviewRatingPercentageType } from '@/serverActions/getReviews'

export default function ReviewDetail({
  reviewSize,
  reviewRating,
  reviewRatingPercentage,
}: {
  reviewSize: number
  reviewRating: number
  reviewRatingPercentage: ReviewRatingPercentageType
}) {
  return (
    <>
      <div className={'c-review-reviewDetail'}>
        <div className={'c-review-reviewDetail__counter'}>
          <p className={cx('u-font-gb', 'c-review-reviewDetail__counter-score')}>
            {reviewRating.toFixed(1)}
            <span className={'c-review-reviewDetail__counter-posts'}>({reviewSize}件)</span>
          </p>
          <ReviewStars reviewRating={reviewRating} scale={32} />
        </div>
        <div className={'c-review-reviewDetail__graph'}>
          <ul className={'c-review-reviewDetail__graph-items'}>
            {Object.keys(reviewRatingPercentage)
              .reverse()
              .map((key) => {
                // @ts-ignore
                const percentage = reviewRatingPercentage[key] * 100
                return (
                  <Fragment key={key}>
                    <li className={'c-review-reviewDetail__graph-item'}>
                      <p className={'c-review-reviewDetail__graph-item--label'}>
                        <span>
                          <ReviewStar scale={20} />
                        </span>
                        <span className={cx('c-review-reviewDetail__graph-item--review-score')}>{key}</span>
                      </p>
                      <div
                        className={'c-review-reviewDetail__graph-bar'}
                        style={{
                          background: `linear-gradient(90deg, rgb(0,0,0) 0%, rgb(0,0,0) ${percentage}%, rgb(237, 237, 236) ${percentage}%, rgb(237, 237, 236) 100%)`,
                        }}
                      />
                      <p className={'c-review-reviewDetail__graph-item--percentage'}>{percentage.toFixed(1)}%</p>
                    </li>
                  </Fragment>
                )
              })}
          </ul>
        </div>
      </div>
    </>
  )
}
